import { NetworkId } from 'modules/network';
import { ProgramId } from 'modules/program';
import { Tracking } from 'modules/tracking';

const BannersTrackings: Record<ProgramId, Record<NetworkId, Tracking>> = {
  // Abritel
  abritel: {
    pz: {
      id: 'abritel',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },

  // Bookabach
  'nz-bookabach': {
    pz: {
      id: 'nz-bookabach',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },

  // Expedia
  'au-expedia': {
    pz: {
      id: 'au-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86804',
    },
  },
  'ca-expedia': {
    pz: {
      id: 'ca-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86805',
    },
  },
  'de-expedia': {
    pz: {
      id: 'de-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87347',
    },
  },
  'fr-expedia': {
    pz: {
      id: 'fr-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87348',
    },
  },
  'hk-expedia': {
    pz: {
      id: 'hk-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87352',
    },
  },
  'jp-expedia': {
    pz: {
      id: 'jp-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87351',
    },
  },
  'kr-expedia': {
    pz: {
      id: 'kr-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86807',
    },
  },
  'mx-expedia': {
    pz: {
      id: 'mx-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l87105',
    },
  },
  'nz-expedia': {
    pz: {
      id: 'nz-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86810',
    },
  },
  'sg-expedia': {
    pz: {
      id: 'sg-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87786',
    },
  },
  'uk-expedia': {
    pz: {
      id: 'uk-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87349',
    },
  },
  'us-expedia': {
    pz: {
      id: 'us-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l75595',
    },
  },

  // FeWo-direkt
  'fewo-direkt': {
    pz: {
      id: 'fewo-direkt',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },

  // Hotels
  'au-hcom': {
    pz: {
      id: 'au-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'br-hcom': {
    pz: {
      id: 'br-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'ca-hcom': {
    pz: {
      id: 'ca-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  // 'de-hcom': {
  //   pz: {
  //     id: 'de-hcom',
  //     baseUrl: 'https://hotels.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'dk-hcom': {
    pz: {
      id: 'dk-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'fi-hcom': {
    pz: {
      id: 'fi-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'fr-hcom': {
    pz: {
      id: 'fr-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  // 'is-hcom': {
  //   pz: {
  //     id: 'is-hcom',
  //     baseUrl: 'https://hotels.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'jp-hcom': {
    pz: {
      id: 'jp-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'kr-hcom': {
    pz: {
      id: 'kr-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'mx-hcom': {
    pz: {
      id: 'mx-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'no-hcom': {
    pz: {
      id: 'no-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'se-hcom': {
    pz: {
      id: 'se-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'tw-hcom': {
    pz: {
      id: 'tw-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'uk-hcom': {
    pz: {
      id: 'uk-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },
  'us-hcom': {
    pz: {
      id: 'us-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: null,
    },
  },

  // Stayz
  'au-stayz': {
    pz: {
      id: 'au-stayz',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },

  // Vrbo
  // 'at-vrbo': {
  //   pz: {
  //     id: 'at-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'au-vrbo': {
  //   pz: {
  //     id: 'au-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'br-vrbo': {
  //   pz: {
  //     id: 'br-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'ca-vrbo': {
    pz: {
      id: 'ca-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },
  // 'dk-vrbo': {
  //   pz: {
  //     id: 'dk-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'es-vrbo': {
  //   pz: {
  //     id: 'es-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'fi-vrbo': {
  //   pz: {
  //     id: 'fi-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'gr-vrbo': {
  //   pz: {
  //     id: 'gr-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'it-vrbo': {
  //   pz: {
  //     id: 'it-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'jp-vrbo': {
  //   pz: {
  //     id: 'jp-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'mx-vrbo': {
  //   pz: {
  //     id: 'mx-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'nl-vrbo': {
  //   pz: {
  //     id: 'nl-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'no-vrbo': {
  //   pz: {
  //     id: 'no-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'nz-vrbo': {
  //   pz: {
  //     id: 'nz-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'pl-vrbo': {
  //   pz: {
  //     id: 'pl-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'pt-vrbo': {
  //   pz: {
  //     id: 'pt-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'se-vrbo': {
  //   pz: {
  //     id: 'se-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'sg-vrbo': {
  //   pz: {
  //     id: 'sg-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'uk-vrbo': {
    pz: {
      id: 'uk-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },
  'us-vrbo': {
    pz: {
      id: 'us-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: null,
    },
  },

  // Wotif
  'au-wotif': {
    pz: {
      id: 'au-wotif',
      baseUrl: 'https://prf.hn/click',
      creativeRef: null,
    },
  },
};

export { BannersTrackings };
